'use strict';

var tooltip = require('../tooltip');
var	page = require('../page');

var SiteConstants = require('../../../../bc_sheplersbootbarn_core/cartridge/js/SiteConstants');

var options = {};
var buffer = {};

function triggerReactWebviewEvent() {
	if ('ReactNativeWebView' in window) {
		window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'order-page' }));
	}
}

function initializePriceSpiderOrderTracking() {
	$(document).on('DataLayer.OrderComplete', function (event, data) {
		if (data && data.dataLayer) {
			var dataLayer = data.dataLayer;
			var psrid = sessionStorage.getItem('psrid');
			if (psrid && dataLayer && 'event' in dataLayer && dataLayer.event == 'purchase') {	
				var itemsTitle = [];
				var itemsPrice = [];
				var itemsQuantity = [];
				var itemsSku = [];
				var itemsManufacturer = [];
				var itemElements = dataLayer.items;
				for (var i = 0; i < itemElements.length; i++) {
					itemsTitle.push(itemElements[i].item_name);
					itemsQuantity.push(itemElements[i].quantity);
					itemsPrice.push(itemElements[i].price);
					itemsSku.push(itemElements[i].item_id);
					itemsManufacturer.push(itemElements[i].item_brand);
				}
				var order = pswtb.purchaseTracking.createOrder();
				order.currencyCode = dataLayer.currency;
				order.purchaseTotal = dataLayer.value;
				var itemsDetails = [];
				for (var y = 0; y < itemsTitle.length; y++) {
					itemsDetails.push({
						"productName": itemsTitle[y],
						"quantity": itemsQuantity[y],
						"unitPrice": itemsPrice[y] / itemsQuantity[y],
						"manufacturer": itemsManufacturer[y],
						"sku": itemsSku[y]
					});
				}
				order.details = itemsDetails;
				order.redirectToken = psrid;
				order.submit();
			}
		}
	});
}

function initializeVWOOrderTracking() {
	buffer['items'] = null;
	if (SitePreferences.VWO_ENABLED && SitePreferences.VWO_PURCHASE_TRACKING_ENABLED) {
		buffer['vwoLoadedInterval'] = setInterval(triggerVWOOrderTracking, 100);

		$(document).on('DataLayer.OrderComplete', function (event, data) {
			var items = [];
			var paymentMethods = '';
			if (data && data.dataLayer) {
				var dataLayer = data.dataLayer;
				if (data && data.options && data.options.PaymentMethod) {
					paymentMethods = data.options.PaymentMethod;
				} else if (data && data.options && data.options.PaymentMethods) {
					paymentMethods = data.options.PaymentMethods.join(' | ');
				} else if (pageContext.PaymentMethods) {
					paymentMethods = pageContext.PaymentMethods.join(' | ');
				}
				for (var itemKey in dataLayer.items) {
					var item = dataLayer.items[itemKey];
					var revenue = item.price;
					var price = revenue;
					if (item.discount) {
						price += item.discount;
					}
					items.push({
						"price": price.toFixed(2),
						"item": item.item_id,
						"paymentMethod": paymentMethods,
						"registeredUser": Customer.registered,
						"revenue": revenue
					});
				}
			}

			if (items && items.length > 0) {
				buffer['items'] = items;
				triggerVWOOrderTracking();
			}
		});
	}
}

function triggerVWOOrderTracking() {
	if (buffer['items'] && window.VWO && window.VWO.event && typeof window.VWO.event == 'function') {
		clearInterval(buffer['vwoLoadedInterval']);
		for (var itemIndex = 0; itemIndex < buffer['items'].length; itemIndex++) {
			var item = buffer['items'][itemIndex];
			VWO.event("purchase", item);
		}
	}
}

function initializeTatariOrderTracking() {
	if (SitePreferences.TATARI_ENABLED) {
		$(document).on('DataLayer.OrderComplete', function (event, data) {
			var maximumAttempts = 50;
			var retryDelay = 100;
			var attempts = 0;
			
			var items = [];
			if (data && data.dataLayer) {
				var orderData = data.dataLayer;
				var orderTotal = orderData.value;
				var orderCurrency = orderData.currency;
				var orderID = orderData.transaction_id;
				
				for (var itemKey in orderData.items) {
					var item = orderData.items[itemKey];
					var price = item.price;

					items.push({
						"name": item.item_name,
						"price": price.toFixed(2),
						"quantity": item.quantity,
						"productID": item.item_id,
						"category": item.item_category + " " + item.item_category2
					});
				}
			}

			if (items && items.length > 0) {
				function sendTatariPurchase() {
					if ( window.tatari && typeof window.tatari.purchase === 'function') {
						window.tatari.purchase({
							total: orderTotal,
							currency: orderCurrency,
							orderId: orderID,
							items: items,
							newPurchase: true
						});
	
						window.console.log(
							'Tatari purchase sent for order:',
							orderID
						);
	
						return;
					}
	
					attempts += 1;
	
					if (attempts < maximumAttempts) {
						window.setTimeout(sendTatariPurchase, retryDelay);
					} else {
						window.console.error(
							'Tatari purchase was not sent: ' +
							'tatari.purchase did not become available.'
						);
					}
				}
				
				sendTatariPurchase();
			}
		});
	}
}

function initializeConfirmationRegistration() {
	var existingCustomer = $('.order-billing-name').attr('has-profile');
	var notRewardsCustomer = $('.order-billing-name').attr('has-rewards');
	var rewardsAdded = $('.rewards-added').data('rewards');
	var firstName = $('input[name="dwfrm_profile_customer_firstname"]').val();
	var lastName = $('input[name="dwfrm_profile_customer_lastname"]').val();
	var email = $('input[name="dwfrm_profile_customer_email"]').val();
	var zip = $('input[name="dwfrm_profile_customer_zip"]').val();
	var phone = $('input[name="dwfrm_profile_customer_phone"]').val();
	var cleanPhone = '';
	if (phone) {
		cleanPhone = phone.replace(/\D/g, '');
	}
	var city = $('.billing-info .city').text().replace(',','');
	var state = $('.billing-info .state').text();
	var country = $('.billing-info .order-billing-country').text();
	var orderNo = $('.orderdetail-section .sectionheader h3').text().replace("Order Number: ","");
	
	$(document).ready(function() {
		if(notRewardsCustomer === "false"){
			if (!rewardsAdded || rewardsAdded == '') {
				$.ajax({
					type: 'post',
					url: Urls.createRewardsAccount,
					contentType: 'application/json',
					data: JSON.stringify({
						firstName: firstName,
						lastName: lastName,
						emailAddress: email,
						phoneNumber: cleanPhone,
						zipCode: zip,
						birthDate: '01/01/1900',
						autoEnroll: true,
						existingCustomer: existingCustomer
					}),
					success: function (data) {
						console.log('Rewards account created.');
					}
				});
			}
		}
	});
	$(document).on('focus', 'input[name^="dwfrm_profile_login_password_"]', function () {
    	$('.register-errors span').addClass('hidden');
    	$('.password-holder').removeClass('error');
    });
	$(document).off('click', 'button.confirmation-register').on('click', 'button.confirmation-register', function (e) {
    	e.preventDefault();
		$('.register-errors span').addClass('hidden');
		$('.password-holder').removeClass('error');
		
    	var isPasswordValid = true;
		var password = $('input[name^="dwfrm_profile_login_password_"]').val();
		var regexPassword = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+={}\[\]:;"'<>,.?\/\\~-])[A-Za-z\d!@#$%^&*()_+={}\[\]:;"'<>,.?\/\\~-]{8,20}$/g;
		if (password.length == 0 || password.match(regexPassword) == null) {
			isPasswordValid = false;
			$('.register-errors span.format-error').removeClass('hidden');
			$('.password-holder').addClass('error');
		}
    	
		if (isPasswordValid) {
			$.ajax({
				url: Urls.registerAccount,
				type: "get",
				data: {
					registerFirstName: firstName,
					registerLastName: lastName,
					registerEmail: email,
					registerZip: zip,
					registerPhone: cleanPhone,
					registerOrderNo: orderNo,
					registerPassword: password
				},
				success: function (response) {
					var data = JSON.parse(response);
						
					if (data.status == 'success') {		
						var auth_data = {
							email: email
						}
						var contact_data = {
						    'channels': {
						        'email': {
						            'address': email
						        }
						    },
							'first_name': firstName,
							'last_name': lastName,
							'phone': cleanPhone,
							'postal_code': zip,
							'source_create': 'confirmation',
							'geo_location': {
							    'postal_code': zip,
							    'country': country,
							    'state': state,
							    'city': city
							}
						};
						var loginProperties = {
						    "email": email
						};			
						if (typeof crdl !== 'undefined' && typeof crdl === 'function') {
							crdl([				
								['contact', auth_data, contact_data],
								['event', 'account_create'],
								['event', 'login', loginProperties]
							]);
						}
					}
					if ($('body').attr('checkout-mode') == 'mobileapp') {
						window.location.href = "bootbarn://account";
					} else {
						window.location.href = Urls.account;
					}
				},
				error: function(jqXHR, textStatus, errorThrown) {
					console.log(textStatus, errorThrown);
				}
			});
		}
	});
}

exports.init = function (optionsParameter) {
	options = optionsParameter;

	tooltip.init({
		items: '.tooltip'
	});
	triggerReactWebviewEvent();
	initializePriceSpiderOrderTracking();
	initializeVWOOrderTracking();
	initializeTatariOrderTracking();
	if (pageContext.site === SiteConstants.SiteIds.BootBarnUS) {
		initializeConfirmationRegistration();
	}
}